import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PermissionContext, Permissions } from '../../types/permissions';

@Injectable({
  providedIn: 'root',
})
export class ApplicationPermissionsApiService {
  constructor(private http: HttpClient) {}

  getPermissions(
    userId: number,
    contexts: Array<{
      context: PermissionContext;
      resourceId?: number;
      supplementalId?: number;
    }>,
  ): Observable<Permissions> {
    const params = new HttpParams();

    return this.http.post<Permissions>(
      `/aptitude/api/users/${userId}/permissionrequests`,
      contexts,
    );
  }

  getContractPermissions(userId: number, cpaId: number, rfpId: number) {
    return this.getPermissions(userId, [
      {
        context: PermissionContext.CONTRACT,
        resourceId: cpaId,
      },
    ]);
  }

  getRfpPermissions(userId: number, rfpId: number) {
    return this.getPermissions(userId, [
      { context: PermissionContext.OPPORTUNITIES, resourceId: rfpId },
      { context: PermissionContext.PURCHASE_PLANNING, resourceId: rfpId },
      { context: PermissionContext.BUYER_RFP, resourceId: rfpId },
    ]);
  }

  getAptitudePermissions(userId: number) {
    return this.getPermissions(userId, [
      { context: PermissionContext.APTITUDE },
    ]);
  }

  getRfpSellerPermissions(userId: number, rfpId: number, orgId: number) {
    return this.getPermissions(userId, [
      {
        context: PermissionContext.SELLER_RFP_RESPONSE,
        resourceId: rfpId,
        supplementalId: orgId,
      },
    ]);
  }
}
